import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { getIntl } from '../../utils/intl';
import { getLabHistoryCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';

const intl = getIntl('use-lab-history', {
    loadError: 'Error occurred loading labs',
});

export type UseLabHistoryArgs = {
    medicalProfileId: string;
    code: string;
};

export type UseLabHistoryReturnValue = {
    isLoadingLabHistory: boolean;
    labHistory: APITypes.medicalDataService.GetLabHistoryResponse;
};

export const useLabHistory = ({ medicalProfileId, code }: UseLabHistoryArgs): UseLabHistoryReturnValue => {
    const labHistoryQuery = useQuery<APITypes.medicalDataService.GetLabHistoryResponse>({
        queryKey: getLabHistoryCacheKey(medicalProfileId, code),
        queryFn: async (): Promise<APITypes.medicalDataService.GetLabHistoryResponse> => {
            const request: APITypes.medicalDataService.GetLabHistoryRequest = { code };
            const response = await appAPI.post<APITypes.medicalDataService.GetLabHistoryResponse>(
                urls.api.medicalData.labHistory(medicalProfileId),
                { body: request },
            );
            return response;
        },
    });

    useQueryErrorNotify(labHistoryQuery, intl('loadError'));

    return {
        isLoadingLabHistory: labHistoryQuery.isLoading,
        labHistory: labHistoryQuery.data || { labHistory: [] },
    };
};
